import React, { Component } from 'react';
import { withRouter } from 'react-router'
// import Search from './Search';
import { connect } from 'react-redux'
import { SearchQ } from '../../graphqlDic'
import { graphql, compose } from 'react-apollo'
import {Link} from 'react-router-dom'

class SearchResult extends Component {
    constructor(props){
      super(props);
     ;
    }
    render() {
      if (this.props.Search.loading) return "Loading...";
      if (this.props.Search.error) return `Error! ${this.props.Search.error.message}`;
        var searchResult = this.props.Search.Search;
        var resultValue = [];
      searchResult.map((result,i) => {
            if (!resultValue[result.type]) resultValue[result.type] = [];
            resultValue[result.type].push(result);
            return resultValue;
        }
    );
      const list_result = resultValue.length ?  resultValue.map((result,i) =>
              <div key ={i}>
              <h4>{(i === 1) ? 'Phim Bộ' : (i === 2) ? 'Phim lẻ' : (i === 3) ? 'Show TV' : (i === 4) ? 'Thể Thao': 'Khác' }</h4>
                <div className="list">
                    <ul className="list-unstyled">
                        {
                            result.map((result,i2) =>
                            <li key={i2}><Link to={"/media/watch/"+result.id}>{result.name}</Link></li>
                            )
                        }
                    </ul>
                </div>
              </div>
    ) : "Không tìm thấy kết quả";
    const resultHtml = resultValue.length ? <div className="search-wrap-content">
            {list_result}
        </div> : ''
      return (
          <div>
            {resultHtml}
        </div>
      );
    }
  }
export default compose(
    graphql(SearchQ,{
        name:'Search',
        options: (ownProps) => ({
            variables: {
                name: ownProps.keyword
            }
        })
    })
)(withRouter(
    connect(
        null
    )(SearchResult)
))


// WEBPACK FOOTER //
// ./src/components/Search/SearchResult.js